import React, { useContext, useState } from 'react'
import { usePopup } from 'react-hook-popup'

import FAQPopup from '../FAQPopup'
import InfoPopup from '../InfoPopup'
import MenuLink from './MenuLink'
import Web3 from 'web3'
import './Menu.css'

import UserContext from '../../context/UserContext'
import toast from 'react-hot-toast'
import { CopyIcon } from '../Icons/CopyIcon'
import { EditIcon } from '../Icons/EditIcon'

enum POPUP {
    INFO = 'INFO',
    FAQ = 'FAQ',
    REQUEST_AUDIT = 'REQUEST_AUDIT',
}

declare let window: any

const Menu = () => {
    const context = useContext(UserContext)

    const [showWhatPopup] = usePopup(POPUP.INFO, ({ handleClose }: any) => {
        return <InfoPopup onClose={handleClose} />
    })

    const [showHowPopup] = usePopup(POPUP.FAQ, ({ handleClose }: any) => {
        return <FAQPopup onClose={handleClose} />
    })
    const [showNavbar, setShowNavbar] = useState(false)

    const handleShowNavbar = () => {
        setShowNavbar(!showNavbar)
    }
    const connectWallet = async () => {
        const { ethereum } = window as any
        if (!ethereum) {
            toast.error('Please install MetaMask first.')
            return
        }

        let web3: Web3 | undefined = undefined
        if (!web3) {
            try {
                // Request account access (replaces ethereum.enable())
                await ethereum.request({ method: 'eth_requestAccounts' })

                // Create Web3 with the injected provider
                web3 = new Web3(ethereum)

                // Example: read chain id (hex from provider; web3 returns number)
                const hexChainId: string = await ethereum.request({ method: 'eth_chainId' })
                const chainId = parseInt(hexChainId, 16)
                console.log('chainId (hex):', hexChainId, 'chainId (num):', chainId)
                console.log('web3.eth.getChainId():', await web3.eth.getChainId())

                // Listen for changes
                ethereum.on('accountsChanged', (accounts: string[]) => {
                    console.log('accountsChanged', accounts)
                    // handle logout / account switch in your app state
                })

                ethereum.on('chainChanged', (_hexId: string) => {
                    // Refresh app state or do a hard reload to avoid stale providers
                    window.location.reload()
                })
            } catch (err: any) {
                // Common MetaMask errors
                // 4001: user rejected request
                // -32002: request already pending (user must open MetaMask)
                // 4100: unauthorized
                // 4902: unknown chain (you may need to add/switch network)
                console.error(err)
                if (err.code === 4001) {
                    toast.error('You rejected the connection request in MetaMask.')
                } else if (err.code === -32002) {
                    toast.error(
                        'A MetaMask request is already pending. Open the extension to continue.'
                    )
                } else {
                    toast.error('Failed to connect to MetaMask.')
                }
                return undefined
            }
        }

        const accounts = await web3.eth.getAccounts()
        if (!accounts.length) {
            toast.error('Please activate MetaMask first.')
            return
        }

        const walletAddress = accounts[0]
        context?.handleContextWallet(walletAddress)
    }

    const MENU = [
        {
            title: 'BN Converter',
            target: '_blank',
            href: 'https://bscscan.com/unitconverter',
        },
        {
            title: 'Decode tx logs',
            href: '/abi',
        },
        {
            title: 'Debug tx',
            href: '/debug',
        },
        {
            title: 'Multicall',
            href: '/multicall',
        },
    ]
    const Hamburger = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="24" viewBox="0 0 52 24">
            <g id="Group_9" data-name="Group 9" transform="translate(-294 -47)">
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 47)"
                    fill="#574c4c"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="42"
                    height="4"
                    rx="2"
                    transform="translate(304 67)"
                    fill="#574c4c"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="52"
                    height="4"
                    rx="2"
                    transform="translate(294 57)"
                    fill="#574c4c"
                />
            </g>
        </svg>
    )

    const mask = (address: string) => {
        return `${address.slice(0, 6) + '******' + address.slice(-4)}`
    }

    return (
        <>
            <div className="menu-icon" onClick={handleShowNavbar}>
                <Hamburger />
            </div>
            <div className={`nav-elements  ${showNavbar && 'active'}`}>
                <ul className="menu">
                    {MENU.map((item, index) => {
                        return (
                            <li className="menu__item" key={index}>
                                <MenuLink href={item.href} target={item.target}>
                                    {item.title}
                                </MenuLink>
                            </li>
                        )
                    })}
                </ul>
                <div className="nav-small">
                    {context?.walletAddress ? (
                        <div className="menu__wallet">{mask(context?.walletAddress)}</div>
                    ) : (
                        <>
                            <MenuLink
                                href="#request_connect"
                                target="_blank"
                                highlight={true}
                                onClick={connectWallet}
                            >
                                Connect Wallet
                            </MenuLink>
                        </>
                    )}
                </div>
            </div>
            <div className="nav-large">
                {context?.walletAddress ? (
                    <div className="menu__wallet-container">
                        <div className="menu__wallet">{mask(context?.walletAddress)}</div>
                        <div onClick={() => navigator.clipboard.writeText(context?.walletAddress)}>
                            <CopyIcon />
                        </div>

                        <div onClick={connectWallet}>
                            <EditIcon />
                        </div>
                    </div>
                ) : (
                    <>
                        <MenuLink
                            href="#request_connect"
                            target="_blank"
                            highlight={true}
                            onClick={connectWallet}
                        >
                            Connect Wallet
                        </MenuLink>
                    </>
                )}
            </div>
        </>
    )
}

export default Menu
